import {Injectable} from '@angular/core';
import { ConfigurationService } from '../configuration.service';

@Injectable({
    providedIn: 'root'
})
export class TasksIconsService {

    constructor(private configService: ConfigurationService) {
    }

    getIcon(option: number) {


        if (this.configService.getMobileConfiguration().mobilehireServiceJobTasks5Options ){
            if (option === 0) {
                return 'close-circle-outline';
            } else if (option === 1) {
                return 'checkmark-circle-outline';
            } else if (option === 2) {
                return 'information-circle';
            } else if (option === 3) {
                return 'remove-circle';
            } else if (option === 4) {
                return 'build';
            } else {
                return 'help';
            }
        }

        if (this.configService.getMobileConfiguration().mobilehireServiceJobTasks2Options ){
            if (option === 0) {
                return 'close-circle-outline';
            } else if (option === 1) {
                return 'checkmark-circle-outline';
            } else if (option === 2) {
                return 'close-circle-outline';
            } else if (option === 3) {
                return 'information-circle';
            }
        }

        
    }

    getColor(option: number) {
        if (option === 0 || option === 4 || !option) {
            return 'danger';
        } else if (option === 1 || option === 2) {
            return 'success';
        } else if (option === 3) {
            return 'warning';
        }
    }
}
